import React, { useState } from 'react';
import InputField from '../../../../component/form/FormInput';
import Button from '../../../../component/ui/Button';
import { toast } from 'react-toastify';
import { formatErrors } from '../../../../utils/controller';
import { createProductGroup } from '../../../../services/products';

const AddProductGroup = ({
	onCLose,
	callBackFunction,
	reloadTable,
	openGroupCode,
	shouldCallCalback = false,
}) => {
	const [error, setError] = useState('');
	const [loader, setLoader] = useState(false);
	const [name, setName] = useState('');

	const submitForm = async (event) => {
		event.preventDefault();
		try {
			if (name !== '' && name !== undefined && name !== null) {
				if (!name.trim()) {
					setError('Group name is required');
					return;
				}

				setLoader(true);
				setError('');
				let body = { name };
				const res = await createProductGroup(body);
				if (res?.success) {
					if (shouldCallCalback) {
						callBackFunction(res?.data?.product_group_id, res.data.code);
					}
					toast.success(res?.message);
					setLoader(false);
					reloadTable();
					onCLose();
					openGroupCode();
				} else {
					formatErrors(res?.response.data?.message);
					toast.error(res?.response?.data?.message);
					setLoader(false);
				}
			} else {
				setError('Please enter group name in the field');
			}
		} catch (error) {
			formatErrors(error?.response.data?.message);
			toast.error(error?.response?.data?.message);
		} finally {
			setLoader(false);
		}
	};

	return (
		<div>
			<form
				onSubmit={submitForm}
				className="add-productgroup-form"
			>
				<InputField
					label="Group Name"
					placeholder="Group Name"
					type="text"
					required={true}
					name="group_name"
					autoFocus={true}
					onChange={(val) => {
						setName(val);
						if (val !== '' && val !== undefined && val !== null) {
							setError('');
						} else {
							setError('Please enter group name in the field');
						}
					}}
					value={name}
					error={error?.name || error}
				/>
				<div className="add-productgroup-footer">
					<Button
						button="Save"
						className="btn-primary add-pgroup"
						loader={loader}
						onClick={submitForm}
					/>
					<Button
						type="button"
						button="Cancel"
						className="btn-dark add-pgroup"
						onClick={onCLose}
					/>
				</div>
			</form>
		</div>
	);
};

export default AddProductGroup;
